@let controls = formGroup.controls;
<header class="page-header">
    <div>
        <h1 class="page-header__title">{{ 'authentication.register.title' | translate }}</h1>
        <p class="page-header__description">{{ 'authentication.register.subtitle' | translate }}</p>
    </div>
</header>
<form class="form-grid" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="form-field">
        <label for="firstNameInput" class="form-field__label form-field__label--required">{{
            'authentication.register.form.firstName' | translate
        }}</label>
        <input type="text" id="firstNameInput" pInputText formControlName="firstName" />
        @if (controls['firstName'].touched && controls['firstName'].errors?.required) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>

    <div class="form-field">
        <label for="lastNameInput" class="form-field__label form-field__label--required">{{
            'authentication.register.form.lastName' | translate
        }}</label>
        <input type="text" id="lastNameInput" pInputText formControlName="lastName" />
        @if (controls['lastName'].touched && controls['lastName'].errors?.required) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>

    <div class="form-field">
        <label for="companyNameInput" class="form-field__label form-field__label--required">{{
            'authentication.register.form.companyName' | translate
        }}</label>
        <input type="text" id="companyNameInput" pInputText formControlName="companyName" />
        @if (controls['companyName'].touched && controls['companyName'].errors?.required) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>

    <div class="form-field">
        <label for="emailInput" class="form-field__label form-field__label--required">{{
            'authentication.register.form.email' | translate
        }}</label>
        <input
            type="text"
            id="emailInput"
            [placeholder]="'authentication.common.placeholder.email' | translate"
            pInputText
            formControlName="email" />
        @if (controls['email'].touched && controls['email'].errors?.required) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
        @if (controls['email'].touched && controls['email'].errors?.email) {
            <small class="p-error">{{ 'authentication.register.validation.invalidEmail' | translate }}</small>
        }
    </div>

    <div class="form-field">
        <label for="passwordInput" class="form-field__label form-field__label--required">{{
            'authentication.register.form.password' | translate
        }}</label>
        <input
            type="password"
            id="passwordInput"
            [placeholder]="'authentication.common.placeholder.newPassword' | translate"
            pPassword
            [feedback]="false"
            formControlName="password" />
        @if (controls['password'].touched && controls['password'].errors?.required) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
        @if (controls['password'].touched && controls['password'].errors?.invalidPassword) {
            <small class="p-error">{{ 'authentication.register.validation.invalidPassword' | translate }}</small>
        }
    </div>

    <div class="form-field">
        <label for="confirmPasswordInput" class="form-field__label form-field__label--required">{{
            'authentication.register.form.confirmPassword' | translate
        }}</label>
        <input
            type="password"
            id="confirmPasswordInput"
            [placeholder]="'authentication.common.placeholder.confirmPassword' | translate"
            pPassword
            [feedback]="false"
            formControlName="confirmPassword" />
        @if (controls['confirmPassword'].touched && controls['confirmPassword'].errors?.required) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
        @if (controls['confirmPassword'].touched && controls['confirmPassword'].errors?.mustMatch) {
            <small class="p-error">{{ 'authentication.register.validation.mustMatch' | translate }}</small>
        }
    </div>

    <div class="form-field">
        <div class="form-choice">
            <p-checkbox
                inputId="register-terms"
                [(ngModel)]="termsAccepted"
                [binary]="true"
                [ngModelOptions]="{ standalone: true }"
                [required]="true"
                [invalid]="submitAttempted && !termsAccepted" />
            <label for="register-terms" [innerHTML]="'home.terms.form.termsCheckboxLabel' | translate"></label>
        </div>
        @if (submitAttempted && !termsAccepted) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>

    <p-button
        type="submit"
        [loading]="loading"
        [label]="'authentication.register.form.submit' | translate"
        [fluid]="true" />
</form>

<p class="text-color-secondary mt-4 text-sm">
    {{ 'authentication.register.loginPrompt' | translate }}
    <a routerLink="/auth/login" class="text-primary font-medium ml-1">
        {{ 'authentication.register.loginLink' | translate }}
    </a>
</p>
